import { defineStore } from 'pinia'


export const useFormErrorsStore = defineStore('formErrors', {
    state: () => {
        return {
            errors: []
        }
    },
    actions: {
        removeErrors(key) {
            if (this.errors[key] !== undefined) {
                delete this.errors[key];
            }
        },
        setErrors(errors) {
            this.errors = errors;
        },
        clearErrors() {
            this.errors = [];
        }
    },
});
